import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import About from "./pages/about";
import India from "./pages/indian";
import Global from "./pages/global";
import Enterprise from "./pages/enterprises";
// import Contact from './pages/contact';
import Header from './component/common/header';
import Footer from './component/common/footer';
import NotFoundPage from "./component/common/notFoundPage";
import './App.css';

const MainLayout = ({ children }) => (
  <>
    {children}
    <Footer />
  </>
);

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gray-100">
        <Header />

        {/* Page routes */}
        <Routes>
          <Route path="/" element={<MainLayout><Home /></MainLayout>} />
          <Route path="/about" element={<MainLayout><About /></MainLayout>} />
          <Route path="/indian" element={<MainLayout><India /></MainLayout>} />
          <Route path="/global" element={<MainLayout><Global /></MainLayout>} />
          <Route path="/enterprise" element={<MainLayout><Enterprise /></MainLayout>} />
          {/* <Route path="/ccl" element={<MainLayout><Contact /></MainLayout>} /> */}

          {/* 404 route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
